/**
 * Time Gutter
 *
 * Left column showing hour labels (07:00, 07:30, 08:00, ...)
 */

import { SLOT_HEIGHT_PX, DEFAULT_START_HOUR, DEFAULT_END_HOUR } from '@/utils/scheduleLayout';

interface TimeGutterProps {
  startHour?: number;
  endHour?: number;
}

export function TimeGutter({
  startHour = DEFAULT_START_HOUR,
  endHour = DEFAULT_END_HOUR,
}: TimeGutterProps) {
  const slots: { label: string; isHour: boolean }[] = [];

  for (let h = startHour; h < endHour; h++) {
    slots.push({
      label: `${h.toString().padStart(2, '0')}:00`,
      isHour: true,
    });
    slots.push({
      label: `${h.toString().padStart(2, '0')}:30`,
      isHour: false,
    });
  }

  return (
    <div className="w-14 shrink-0 border-r border-border-primary relative">
      {slots.map((slot, i) => (
        <div
          key={i}
          className="flex items-start justify-end pr-2"
          style={{ height: `${SLOT_HEIGHT_PX}px` }}
        >
          <span
            className={`text-[9px] -mt-1.5 ${
              slot.isHour
                ? 'text-text-tertiary font-medium'
                : 'text-text-quaternary/50'
            }`}
          >
            {slot.isHour ? slot.label : ''}
          </span>
        </div>
      ))}
    </div>
  );
}
